import { INJECTIONS_SET, INJECTION_ADDED, INJECTION_EDITED, INJECTION_DELETED } from 'src/app/redux/redux-types';
import { reduxInjectionTypes } from 'src/types';

export const injectionDefaultState: reduxInjectionTypes.StateType = {
  injectionList: [],
};

export const injectionReducer = (
  state = injectionDefaultState,
  action: reduxInjectionTypes.ActionType,
): reduxInjectionTypes.StateType => {
  switch (action.type) {
    case INJECTIONS_SET:
      return {
        ...state,
        injectionList: action.payload,
      };
    case INJECTION_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.injectionList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        injectionList: [action.payload, ...state.injectionList],
      };
    case INJECTION_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.injectionList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        injectionList: [
          ...state.injectionList.slice(0, updateIndex),
          action.payload,
          ...state.injectionList.slice(updateIndex + 1),
        ],
      };
    case INJECTION_DELETED:
      return {
        ...state,
        injectionList: state.injectionList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
